import { Catalog } from './Catalog.interface';

// The decision has been made to hardcode the catalog on the frontend.
// However, this choice should be re-discussed because having the products on the backend will offer :
//   - better data correctness
//   - less boilerplate to pass the "données formulaires" to Salesforce
//   - etc.
// Since the data is from an external file, the "enSavoirPlus" lines are exceptionnally longer than 80 characters
export const allProducts: Catalog = {
    groups: [
        {
            code: 'activite',
            name: 'Pour votre activité',
            products: [
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'MRP',
                    enSavoirPlus: 'L’offre Assurance Multirisque permet d’avoir des garanties modulables au plus près de vos besoins pour assurer vos locaux, votre matériel, vos marchandises et votre responsabilité civile, tout en garantissant la pérennité de votre entreprise.',
                    libelleProduit: 'Assurance multirisque professionnelle',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'RCPRO',
                    enSavoirPlus: 'L\'offre Assurance Responsabilité Civile Entreprise vous protège contre les dommages ou des préjudices (accident, malfaçon, erreur de livraison...) occasionnés à un tiers (client, founisseur...), que ce soit pour vous-même, vos salariés, vos locaux ou votre matériel professionnel.',
                    libelleProduit: 'Responsabilité civile de l\'entreprise',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'RCDECENNALE',
                    enSavoirPlus: 'L\'offre Responsabilité Civile Décennale vous protège, vous dirigeant et votre entreprise, contres les dommages causés à un tiers dans le cadre de votre activité. Il s\'agit d\'une assurance réglementaire indispensable dans certains corps de métiers.',
                    libelleProduit: 'Responsabilité civile décennale',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'PJPRO',
                    enSavoirPlus: 'L\'offre Protection Juridique vous couvre efficacement contre les risques juridiques auxquels vous pouvez être confronté dans le cadre de votre activité et sur internet. Usurpation d\'identité, conflits avec un salarié, retard fournisseur, autant d\'éléments qui penvent être pris en charge.',
                    libelleProduit: 'Protection juridique',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'AUTOPRO',
                    enSavoirPlus: 'L\'offre Assurance Véhicule Professionnel vous permet d\'être assuré en cas de panne au moment de livrer vos clients, d\'accident avec le véhicule de votre entreprise, ou de vol de véhicule avec votre matériel professionnel.',
                    libelleProduit: 'Assurance véhicule professionnel',
                    visible: true,
                },
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'EMPRUNTEUR',
                    enSavoirPlus: 'L\'offre Assurance Emprunteur vous permet d\'assurer vos prêts. Adaptée à vote activité et à votre situation, elle peut vous permettre de réaliser des économies sur le financement d\'un fonds de commerce, d\'équipement ou de locaux.',
                    libelleProduit: 'Assurance emprunteur',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'MULTIRISQUEINFO',
                    enSavoirPlus: 'L\'offre Assurance Multirisque informatique vous permet d\'assurer l\'ensemble de votre matériel informatique ainsi que vos données en cas de vol de matériel, incendie, dommages électriques ou bris accidentel.',
                    libelleProduit: 'Assurance multirisque informatique',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'MULTIRISQUEAGRICOLE',
                    enSavoirPlus: 'L’offre Assurance Multirisque Agricole vous offre une protection complète pour votre activité professionnelle, votre exploitation et vos biens privés. Elle est adaptée aux secteurs agricoles en production végétale, animale ainsi que les centres équestres, les apiculteurs etc…',
                    libelleProduit: 'Assurance multirisque agricole',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'DIVERSIARD',
                    enSavoirPlus: 'Vous ne trouvez pas le produit d\'assurance professionnelle dont vous avez besoin ? Qu\'il s\'agisse de protection de location de matériel, d\'activités de transport et logistique ou bien d\'autres encore, votre conseiller saura vous aider à trouver l\'offre qui vous convient.',
                    libelleProduit: 'Autres produits d\'assurances professionnelles',
                    visible: true,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'CREDIT',
                    enSavoirPlus: 'En vendant à crédit, vous subissez les retards de paiement de vos clients et risquez les impayés! Nous vous aidons à choisir des clients solvables et maîtriser vos risques.',
                    libelleProduit: 'Assurance crédit',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'FLOTTE',
                    enSavoirPlus: 'Accident, car-jacking, panne ou catastrophe naturelle : protégez vos véhicules professionnels, bénéficiez de services de prévention et d\'une assistance personnalisée',
                    libelleProduit: 'Assurance flotte de véhicules',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'BRISDEMACHINE',
                    enSavoirPlus: 'Pour protéger les machines et équipements techniques indispensables à votre activité.',
                    libelleProduit: 'Assurance bris de machine',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'LOCATIONMATERIEL',
                    enSavoirPlus: 'Louez les matériels ou engins nécessaires à votre activité en étant bien assuré.',
                    libelleProduit: 'Assurance location de matériel',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'RISQUESENVIRONNEMENTAUX',
                    enSavoirPlus: 'Pour faire face aux évolutions réglementaires en matière de protection de l’environnement.',
                    libelleProduit: 'Assurance risques environnementaux',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'RCTRANSPORT',
                    enSavoirPlus: 'Transporteurs, déménageurs, loueurs de véhicules, manutentionnaires ou opérateurs, bénéficiez d\'une couverture complète dans le cadre de vos activités de transport et de logistique.',
                    libelleProduit: 'Responsabilité civile des professionnels du transport',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'MARCHANDISES',
                    enSavoirPlus: 'Un contrat qui couvre l\'ensemble des flux de marchandises, en phases de transit, de stockage et points de vente, quelque soit le mode de transport : voie terrestre, maritime, fluviale, aérienne ou ferroviaire.',
                    libelleProduit: 'Assurance marchandises transportées',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'CYBERRISQUES',
                    enSavoirPlus: 'Protégez votre entreprise contre les cyber-risques avec une offre d’assurance dédiée, tout en continuant à développer sereinement votre activité. ',
                    libelleProduit: 'Assurance cyber-risques',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'ANNULATIONEVENEMENTS',
                    enSavoirPlus: 'Concert, événement sportif, séminaire, exposition: l’annulation d’un évènement a un impact sur la santé financière de votre entreprise. Nous vous proposons une offre adaptée à vos activités.',
                    libelleProduit: 'Assurance annulation d’événements',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'RISQUESINDUSTRIELS',
                    enSavoirPlus: 'L\'indemnisation de vos bâtiments, installations, matériels et marchandises en cas d’incendie, d’explosion, de dommages électriques, d’événements naturels et autres périls tels que le vandalisme, en adaptant vos garanties aux particularités de vos installations à assurer. Et en cas de dommages causés à des tiers ou à des salariés, la garantie responsabilité civile, vous protège vous et votre entreprise.',
                    libelleProduit: 'Assurance risques industriels',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'MATERIELAGRICOLE',
                    enSavoirPlus: 'Un seul contrat pour couvrir vos engins et machines agricoles de tous les dommages qu’ils peuvent subir, mais aussi de ceux qu’ils peuvent causer à des tiers.',
                    libelleProduit: 'Assurance matériel agricole',
                    visible: false,
                },
                {
                    categorieProduit: 'IARD',
                    codeProduit: 'PACKMICROENTREPRENEUR',
                    enSavoirPlus: 'Que vous soyez entrepreneurs individuels, micro-entrepreneurs ou travailleurs indépendants exerçant sans salarié, Mon Pack Entrepreneur est la solution simple et « tout en 1 » pour assurer votre activité : couverture de votre matériel et marchandises en cas de dommages, responsabilité civile professionnelle, indemnités journalières en cas d’arrêt de travail à la suite d’un accident, accompagnement juridique en cas de litiges.',
                    libelleProduit: 'Mon Pack Entrepreneur',
                    visible: false,
                },
            ],
        },
        {
            code: 'dirigeant',
            name: 'Pour les dirigeants',
            products: [
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'RCDIRIGEANT',
                    enSavoirPlus: 'L\'offre Responsabilité Dirigeant couvre votre responsabilité personnelle et protège votre famille et votre patrimoine en cas d\'erreur ou de négligence de votre part. Elle permet un accompagnement juridique, des solutions concrètes en cas de crise, ainsi que la prise en charge de vos frais de défense.',
                    libelleProduit: 'Responsabilité civile du dirigeant',
                    visible: true,
                },
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'SANTEDIRIGEANT',
                    enSavoirPlus: 'L\'offre Assurance Santé Dirigeant vous permet d\'accéder à des garanties protectrices pour vous et votre famille, que ce soit pour les soins courants ou en cas d\'hospitalisation. Elle comprend aussi une gestion facilitée de vos remboursements, ainsi que des services adaptés à votre emploi du temps.',
                    libelleProduit: 'Complémentaire santé dirigeant',
                    visible: true,
                },
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'PREVOYANCEDIRIGEANT',
                    enSavoirPlus: 'L\'offre Assurance Prévoyance Dirigeant est un contrat sur mesure qui permet de vous mettre à l\'abri vous et vos proches en cas de potentielles difficultés financières, d\'incapacité de travail, d\'invalidité ou de décès.',
                    libelleProduit: 'Prévoyance du dirigeant',
                    visible: true,
                },
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'PREVOYANCEAGRICOLE',
                    enSavoirPlus: 'L\'offre Prévoyance Agricole vous permet de vous asssurer pour les risques liés au décès, à l\'invalidité et à l\'incapacité temporaire de travail, quelles que soient les circonstances. C\'est un complément indispensable aux prestations de Régime Obligatoire.',
                    libelleProduit: 'Prévoyance agricole',
                    visible: true,
                },
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'EPARGNERETRAITEDIRIGEANT',
                    enSavoirPlus: 'Nos offres en épargne salariale et retraite d\'entreprise vous permettent d\'accompagner les salariés dans la préparation de leurs projets et leur retraite dans un cadre fiscal avantageux. Plan Epargne Entreprise (PEE), Plan Epargne Retraite (PER) et bien d\'autres sont à votre disposition.',
                    libelleProduit: 'Plan épargne retraite du dirigeant',
                    visible: true,
                },
            ],
        },
        {
            code: 'salaries',
            name: 'Pour les salariés',
            products: [
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'SANTESALARIES',
                    enSavoirPlus: 'L\'offre Assurance Santé Salarié est obligatoire et s\'impose à chaque employeur. Pour concilier les intérêts de l\'entreprise avec les attentes des collaborateurs, nous proposons une offre modulable adaptée à tous les budgets.',
                    libelleProduit: 'Complémentaire santé salariés',
                    visible: true,
                },
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'PREVOYANCESALARIES',
                    enSavoirPlus: 'L\'offre Assurance Prévoyance Salarié compense une partie de la perte de revenus en cas d\'arrêt de travail, ou d\'invalidité de vos salariés suite à une maladie ou un accident. Elle permet également de verser un capital à la famille en cas de décès.',
                    libelleProduit: 'Prévoyance collective',
                    visible: true,
                },
                {
                    categorieProduit: 'VIE',
                    codeProduit: 'EPARGNERETRAITESALARIES',
                    enSavoirPlus: 'Nos offres en épargne salariale et retraite d\'entreprise vous permettent d\'accompagner les salariés dans la préparation de leurs projets et leur retraite dans un cadre fiscal avantageux. Plan Epargne Entreprise (PEE), Plan Epargne Retraite (PER) et bien d\'autres sont à votre disposition.',
                    libelleProduit: 'Plan épargne retraite des salariés',
                    visible: true,
                },
            ],
        },
    ],
};

export const catalog: Catalog = {
    ...allProducts,
    groups: allProducts.groups.map(group => ({
        ...group,
        products: group.products.filter(product => product.visible),
    })),
};
